<template>
	<div class="charge">
		<!-- left -->
		<div class="main-left">
			收费管理
		</div>
		<div class="main-right">
			
		</div>
	</div>
</template>

<script>
	export default {
		components: {
			
		},
		data() {
			return {
			// str
			
			// number
			pageNum: 1, //当前页currentPage
			pageSize: 8,
			totalSize: 10, //总条数
			// arr
			data: [],
			elTree:[{ label: '全部', path:'', title:'', icon:'el-icon-news'}],
			tableData: []
			};
		},
		mounted() {
			
		},
		methods:{
			
		},
		
	}
</script>

<style lang="less" scoped>
	.charge{
		padding: 12px;
	}
</style>